import PostTeaser from './post-teaser'

export default PostTeaser
